import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
  ReferenceLine,
} from "recharts";
import "./WaterFallChart.scss";

const WaterFallChart = ({ data }) => {
  const formatLabel = (value) => {
    const absValue = Math.abs(value).toLocaleString();
    return value < 0 ? `-$${absValue}` : `$${absValue}`;
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} margin={{ top: 30, bottom: 0 }}>
        <defs>
          <linearGradient id="greenGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#90DB8B" />
            <stop offset="100%" stopColor="#57D64E" />
          </linearGradient>
          <linearGradient id="redGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#FF5252" />
            <stop offset="100%" stopColor="#D32F2F" />
          </linearGradient>
          <linearGradient id="blueGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#BABCFC" />
            <stop offset="100%" stopColor="#4348E3" />
          </linearGradient>
        </defs>

        <XAxis dataKey="name" axisLine={false} tickLine={false} dy={-50} />
        <ReferenceLine y={0} stroke="black" strokeDasharray="5 5" />

        <Bar
          dataKey="value"
          cursor="pointer"
          fillOpacity={1}
          radius={[10, 10, 0, 0]}
        >
          {data.map((entry, index) => (
            <Bar
              key={index}
              dataKey="value"
              fill={entry.value < 0 ? "url(#redGradient)" : entry.fill}
            />
          ))}
          <LabelList
            dataKey="value"
            position="top"
            formatter={formatLabel}
            offset={10}
          />
        </Bar>

        <Tooltip
          wrapperStyle={{ outline: "none" }}
          contentStyle={{
            backgroundColor: "white",
            border: "1px solid #ddd",
          }}
          cursor={{ fill: "transparent" }}
          formatter={(value) => {
            const absValue = Math.abs(value).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
            const formatted = value < 0 ? `-$${absValue}` : `$${absValue}`;
            return [formatted, "Amount"];
          }}
          labelFormatter={(label) => label}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default WaterFallChart;
